export enum EntityType {
  User = "User",
  UserGroup = "UserGroup",
  ApiKey = "ApiKey",
}

export type EntityWithRoleBinding = {
  type: EntityType;
  id: string;
  name: string;
  roleBindingId: string;
  space: {
    id: string;
    name: string;
  };
  isLastRole: boolean;
};

export type CellComponentProps = {
  entity: EntityWithRoleBinding;
};
